import React, { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { generateTransactionId } from "../Utils/UtilsFunc";
import axios from "axios";
import { baseURL } from "../../token";

const UpiPaymentGateway = ({ userData, setting }) => {
  const [depositAmount, setDepositAmount] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState();
  const [paymentWindowRef, setPaymentWindowRef] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const errorParam = searchParams.get("error");
    if (errorParam) {
      setMessage(errorParam);
    }
  }, [location.search]);

  useEffect(() => {
    if (
      message ===
      "Transaction Successful, Amount Has been added to your account!..."
    ) {
      console.log(message);
    } else {
      console.error(message);
    }
  }, [message]);

  console.log(userData.Wallet_balance);
  const handlePayClick = async (data) => {
    if (depositAmount < setting?.minimumDeposit) {
      console.error(`Minimum deposit amount is ${setting?.minimumDeposit}`);
      return;
    }
    if (depositAmount > setting?.maximumDeposit) {
      console.error(`Maximum Deposit is ${setting?.maximumDeposit}`);
      return;
    }
    const depositData = {
      key: setting?.upiGatewayKey,
      p_info: setting?.WebsiteName,
      customer_mobile: String(userData?.Phone),
      customer_email: userData?.Email || "metaludo@gamil.com",
      customer_name: userData?.Name,
      amount: depositAmount,
      client_txn_id: generateTransactionId(userData?.Phone),
      udf1: userData?._id,
      udf2: String(userData?.Wallet_balance),
      //   redirect_url: `${baseURL}/getUpiGatewayPaymentDetails`,
      redirect_url: `https://backend.redbullludo.com/getUpiGatewayPaymentDetails`,
    };

    try {
      const access_token = localStorage.getItem("access_token");
      if (!access_token) {
        console.error("No access token found");
        return;
      }
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      const response = await axios.post(
        `${baseURL}/upiGatewayDoPayment`,
        depositData,
        { headers } // Pass headers here
      );

      console.log(response.data);
      if (response.data.status) {
        console.log(response.data);
        // Store token before opening payment URL to ensure session persistence
        const tokenBeforePayment = localStorage.getItem("access_token");
        // Open payment in new tab but keep token safe
        const paymentWindow = window.open(response.data.data.payment_url);
        setPaymentWindowRef(paymentWindow);
        
        // Check periodically if payment window closed (payment completed)
        const checkWindowClosed = setInterval(() => {
          if (paymentWindow && paymentWindow.closed) {
            clearInterval(checkWindowClosed);
            // Restore token if needed
            if (!localStorage.getItem('access_token') && tokenBeforePayment) {
              localStorage.setItem('access_token', tokenBeforePayment);
            }
            // Redirect to wallet page after payment
            setTimeout(() => {
              navigate('/WalletPage');
            }, 1000);
          }
        }, 1000);
        
        // Restore token on focus back to main window
        window.addEventListener('focus', () => {
          if (!localStorage.getItem('access_token') && tokenBeforePayment) {
            localStorage.setItem('access_token', tokenBeforePayment);
          }
        });
      } else {
        console.error(response.data.message || "Payment creation failed");
      }
    } catch (error) {
      if (error?.response?.data) {
        console.error(error.response.data.message);
      } else {
        console.error("An error occurred:", error.message);
      }
    }
  };

  return (
    <div>
      <div className="col-12 my-3">
        <label htmlFor="username" className="text-left text-yellow">
          Enter Amount
        </label>
      </div>
      <div className="col-12 mb-4 d-flex justify-content-center">
        <button id="buy-chips-btn" className="text-light">
          <i className="bi bi-currency-rupee" />
        </button>
        <input
          id="buy-chips-input"
          className="text-yellow"
          type="text"
          onChange={(e) => setDepositAmount(e.target.value)}
          value={depositAmount}
        />
      </div>
      <div className="col-12 mb-4 d-flex justify-content-center flex-wrap gap-2">
        {[300, 500, 1000, 2000].map((amount) => (
          <button
            key={amount}
            type="button"
            className={`btn btn-sm ${
              depositAmount == amount
                ? 'btn-warning text-dark'
                : 'btn-outline-warning text-yellow border-warning'
            }`}
            onClick={(e) => {
              e.preventDefault();
              setDepositAmount(amount);
            }}
            style={{ minWidth: '60px' }}
          >
            ₹{amount}
          </button>
        ))}
      </div>
      <div className="col-12">
        <a>
          <p>{message}</p>
          <button className="bg-orange btn" onClick={handlePayClick}>
            Pay
          </button>
        </a>
      </div>
    </div>
  );
};

export default UpiPaymentGateway;
